import React from 'react';
import { ShieldAlert } from 'lucide-react';
import './ButtonDesconocido.css';

const ButtonDesconocido = ({ onClick, disabled = false }) => {
  return (
    <button className="boton-desconocido" onClick={onClick} disabled={disabled} title="Marcar como desconocido">
      <ShieldAlert />
    </button>
  );
};

export default ButtonDesconocido;
